<template>
    <div class="f-topic-official">
        <div class="f-topic-official-icon" @click="toggleShow">
            <div v-if="isShowOfficial">
                <span>收起</span>
                <span class="fa fa-caret-up"></span>
            </div>
            <div v-else>
                <span>展开</span>
                <span class="fa fa-caret-down"></span>
            </div>
        </div>

        <!-- 展开 -->
        <div v-show="isShowOfficial" class="f-topic-official-more">
            <!-- 固定展示，同收起 -->
            <base-info></base-info>

            <!-- 主处理流程 -->
            <main-process></main-process>
        </div>

        <!-- 收起 -->
        <less-info v-show="!isShowOfficial"></less-info>
    </div>
</template>

<style lang="less">
    @import '../../../../assets/less/views/topic-content/official-process/official-process-board.less';
</style>

<script>
import BaseInfo from './BaseInfo.vue';
import LessInfo from './LessInfo.vue';
import MainProcess from './MainProcess.vue';

import {mapGetters} from 'vuex';

export default {
    components: {
        'base-info': BaseInfo,
        'less-info': LessInfo,
        'main-process': MainProcess
    },
    data() {
        return {
            isShowOfficial: true
        };
    },
    computed: {
        ...mapGetters(['isActiveWithoutFollower', 'isClosed'])
    },
    mounted() {
        // 新建无跟进人 or 已完成，板块默认收起
        if (this.isActiveWithoutFollower || this.isClosed) {
            this.isShowOfficial = false;
        }
    },
    methods: {
        toggleShow() {
            this.isShowOfficial = !this.isShowOfficial;
        }
    }
};
</script>
